<template>
	<div class="changelog-subview">
		<div v-if="type" id="changeLogSubview">
			<crm-table v-if="restApi" :rest-api="restApi"></crm-table>
			<div v-else>srcType {{ sourceType }} must have changeLog endpoint defined (see SourceType.java)</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import {computed, ref, watch} from "vue";
import {injectEnv} from "@fd/Environment.ts";
import {ContextKey, getIntValue, injectContext} from "@t/fd/AppContext.ts";
import CrmTable from "@/vue/table/CrmTable.vue";
import {loadSourceType, setEndpointId, SourceType} from "@t/meta/SourceType.ts";

const env = injectEnv();
const ctx = injectContext();
const sourceType = computed<number>(() => getIntValue(ctx.value, ContextKey.SRC_TYPE));
const sourceId = computed<string|number>(() => getIntValue(ctx.value, ContextKey.SRC_ID));

const type = ref<SourceType>(null);

watch(sourceType, async ()=> {
	if (sourceType.value) {
		if (type.value == null || type.value.id !== sourceType.value) {
			type.value = await loadSourceType(env, sourceType.value);
		}
	} else {
		type.value = null;
	}
}, { immediate: true });

const restApi = computed<string>(() => {
	if (type.value == null || type.value.changeLog == null) return null;
	return setEndpointId("api" + type.value.changeLog, sourceId.value);
});
</script>

<style>
.changelog-subview {
	padding-top: 8px;
}
</style>